import React from 'react'
import styled from 'styled-components'
import {Mutation, graphql, compose, Query} from 'react-apollo'
import {get} from 'lodash'

import {requireAuthAndProject} from '../../../../../auth'

import BotGenderSettingSector from './components/BotGenderSettingSector'
import ShopDetailSector from './components/ShopDetailSector'
import PaymentSector from './components/PaymentSector'
import VATSector from './components/VATSector'
import GreetingMessageSector from './components/GreetingMessageSector'
import ProductDisplaySettingSector from './components/ProductDisplaySettingSector'

import {
  BOT_GENDER,
  GET_ALL_STORE_SETTING_DATA,
  GET_SEARCH_PRODUCTS_ORDER,
  VAT,
} from '../../../../../graphql/query'
import {
  UPDATE_BOT_GENDER,
  UPDATE_GREETINGS_MESSAGE,
  UPDATE_PAYMENT,
  UPDATE_SEARCH_PRODUCTS_ORDER,
  UPDATE_SHOP,
  UPDATE_VAT_V2,
} from '../../../../../graphql/mutation'

const StoreSettingSectorWrapper = styled.div`
  padding: 32px;
`

class StoreSettingPage extends React.Component {
  hasEditPermission = () => {
    return this.props.project.role === 'owner'
  }

  render() {
    const readOnly = !this.hasEditPermission()
    return (
      <React.Fragment>
        <StoreSettingSectorWrapper>
          <Mutation
            mutation={UPDATE_SHOP}
            refetchQueries={[
              {
                query: GET_ALL_STORE_SETTING_DATA,
                variables: {
                  projectId: this.props.project.id,
                },
              },
            ]}
          >
            {updateShopDetail => {
              return (
                <ShopDetailSector
                  disabled={readOnly}
                  onSave={updateShopDetail}
                  value={this.props.shopDetail}
                  project={this.props.project}
                  isShowTaxInfo={this.props.vat.isShowTaxInfo}
                />
              )
            }}
          </Mutation>
        </StoreSettingSectorWrapper>
        <StoreSettingSectorWrapper>
          <Mutation
            mutation={UPDATE_PAYMENT}
            refetchQueries={[
              {
                query: GET_ALL_STORE_SETTING_DATA,
                variables: {
                  projectId: this.props.project.id,
                },
              },
            ]}
          >
            {updatePayment => {
              return (
                <PaymentSector
                  disabled={readOnly}
                  onSave={updatePayment}
                  value={this.props.payment}
                  project={this.props.project}
                />
              )
            }}
          </Mutation>
        </StoreSettingSectorWrapper>
        <StoreSettingSectorWrapper>
          <Mutation
            mutation={UPDATE_VAT_V2}
            refetchQueries={[
              {
                query: VAT,
                variables: {
                  projectId: this.props.project.id,
                },
              },
            ]}
          >
            {updateVat => {
              return (
                <VATSector
                  disabled={readOnly}
                  onSave={updateVat}
                  value={this.props.vat}
                  project={this.props.project}
                  shopDetail={this.props.shopDetail}
                />
              )
            }}
          </Mutation>
        </StoreSettingSectorWrapper>
        <StoreSettingSectorWrapper>
          <Mutation
            mutation={UPDATE_GREETINGS_MESSAGE}
            refetchQueries={[
              {
                query: GET_ALL_STORE_SETTING_DATA,
                variables: {
                  projectId: this.props.project.id,
                },
              },
            ]}
          >
            {updateGreetingMessage => {
              return (
                <GreetingMessageSector
                  disabled={readOnly}
                  onSave={updateGreetingMessage}
                  value={this.props.greetingMessage}
                  project={this.props.project}
                />
              )
            }}
          </Mutation>
        </StoreSettingSectorWrapper>
        <StoreSettingSectorWrapper>
          <Query
            query={GET_SEARCH_PRODUCTS_ORDER}
            variables={{projectId: this.props.project.id}}
          >
            {({loading, error, data}) => {
              if (loading) return 'loading'
              if (error) return 'error'
              return (
                <Mutation
                  mutation={UPDATE_SEARCH_PRODUCTS_ORDER}
                  refetchQueries={[
                    {
                      query: GET_SEARCH_PRODUCTS_ORDER,
                      variables: {
                        projectId: this.props.project.id,
                      },
                    },
                  ]}
                >
                  {updateSearchOrder => {
                    return (
                      <ProductDisplaySettingSector
                        onSave={updateSearchOrder}
                        value={data.getSearchProductsOrder}
                        projectId={this.props.project.id}
                      />
                    )
                  }}
                </Mutation>
              )
            }}
          </Query>
        </StoreSettingSectorWrapper>
        <StoreSettingSectorWrapper>
          <Query
            query={BOT_GENDER}
            variables={{projectId: this.props.project.id}}
          >
            {({loading, error, data}) => {
              const botGender = get(data, 'getProject.botGender', 'FEMALE')

              if (loading) return 'loading'
              if (error) return 'error'
              return (
                <Mutation mutation={UPDATE_BOT_GENDER}>
                  {updateBotGender => {
                    return (
                      <BotGenderSettingSector
                        onSave={updateBotGender}
                        value={botGender}
                        projectId={this.props.project.id}
                      />
                    )
                  }}
                </Mutation>
              )
            }}
          </Query>
        </StoreSettingSectorWrapper>
      </React.Fragment>
    )
  }
}

export default compose(
  requireAuthAndProject,
  graphql(GET_ALL_STORE_SETTING_DATA, {
    props: props => {
      const {data} = props
      const {greetingMessage, shopDetail, payment} = data
      const promptpayAccountName = get(payment, 'promptPay.accountName') || ''
      const promptpayNumber = get(payment, 'promptPay.accountNo') || ''

      return {
        greetingMessage: {
          message1: get(greetingMessage, '0.value') || '',
          message2: get(greetingMessage, '1.value') || '',
        },
        shopDetail: {
          image: get(shopDetail, 'image') || '',
          shopName: get(shopDetail, 'general.name') || '',
          address: get(shopDetail, 'general.address.address_1') || '',
          district: get(shopDetail, 'general.address.district') || '',
          subDistrict: get(shopDetail, 'general.address.subDistrict') || '',
          province: get(shopDetail, 'general.address.province') || '',
          postcode: get(shopDetail, 'general.address.postcode') || '',
          branch: get(shopDetail, 'general.address.branch') || '',
          phoneNumber: get(shopDetail, 'general.phoneNumber') || '',
          facebook: get(shopDetail, 'socialMedia.facebook') || '',
          instagram: get(shopDetail, 'socialMedia.instagram') || '',
          twitter: get(shopDetail, 'socialMedia.twitter') || '',
          website: get(shopDetail, 'socialMedia.website') || '',
        },
        payment: {
          bankAccounts: (get(payment, 'bankAccounts') || []).map(
            bankAccount => ({
              accountName: bankAccount.accountName || '',
              accountNo: bankAccount.accountNo || '',
              bankName: bankAccount.bankName || '',
              branch: bankAccount.branch || '',
              accountType: bankAccount.accountType || '',
            }),
          ),
          enablePromptpay: Boolean(promptpayAccountName && promptpayNumber),
          promptpayAccountName,
          promptpayNumber,
        },
      }
    },
    options: props => {
      return {
        variables: {
          projectId: props.project.id,
        },
      }
    },
  }),
  graphql(VAT, {
    props: props => {
      const {data} = props
      const {vat} = data

      return {
        vat: {
          id: get(vat, 'id'),
          vatId: get(vat, 'taxId') || '',
          vatOptions: get(vat, 'option') || 'NONE',
          vatPercentage: get(vat, 'rate') || 7,
          isShowTaxInfo: get(vat, 'isShowTaxInfo') || false,
        },
      }
    },
    options: props => {
      return {
        variables: {
          projectId: props.project.id,
        },
      }
    },
  }),
)(StoreSettingPage)



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/storeSettings/StoreSettingPage.js